/**
 * Created by Arif Topcu in 2019
 */

import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ComplicationSelector from "@ls/grouping-complication-selector";
import CashFlowDefinition from "state/cf/CashFlowDefinition";
import Complication from "./CashFlowSelectorComplication";
import { selectDefinitions } from "state/cf/selectors";
import SelectionState from "state/selections/SelectionState";
import { setDefinition as setCfDefinition } from "state/cf/actions";

const CashFlowSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setCfDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={CashFlowDefinition.getDefault}
      ComplicationComponent={Complication}
      btnTitle={"Cash Flow"}
      addMoreText={"Cash Flow Column"}
    />
  );
};

export default CashFlowSelector;
